// Manual-draft boundary: a draft is consumed only when the existing score
// authority reports successful durable queue insertion. Mutating the shared
// round-local draft map also makes repeated calls in the same tick idempotent.
export function commitGolfScoreDraft({ drafts, key, score, commit }) {
  if (drafts[key] !== score) return false
  if (commit() !== true) return false
  delete drafts[key]
  return true
}
